import { TrackJS } from 'trackjs';
/**
 * Setup trackJS tracker for the components.
 * Only needs to run once
 */
export const setupTrackErrors = () => {
    var _a;
    if (typeof process !== 'undefined' && ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.DEBUGG) !== 'false') {
        if (!TrackJS.isInstalled()) {
            const options = {
                application: 'nmp-trust',
                token: '74bb3e28a1604fd2b28c72c568722d21',
                forwardingDomain: 'www.finn.no',
                callback: { enabled: false },
                console: { enabled: false },
                network: { enabled: false },
                visitor: { enabled: false },
                window: { enabled: false },
            };
            TrackJS.install(options);
        }
    }
};
/**
 * Try catch around code that might fail and logs error to trackjs with correct metadata
 */
export const trackErrorWrapper = (func) => {
    try {
        return func();
    }
    catch (error) {
        trackError(error);
        return undefined;
    }
};
/**
 * Try catch around async code that might fail and logs error to trackjs with correct metadata
 */
export const trackErrorWrapperAsync = async (func) => {
    try {
        return (await func() || {});
    }
    catch (error) {
        trackError(error);
        return { error: {} };
    }
};
/**
 * Track error with correct metadata
 */
export const trackError = (error) => {
    TrackJS.addMetadata('pkg', 'nmp-trust');
    console.log(error);
    TrackJS.track(error);
    TrackJS.removeMetadata('pkg');
};
/**
 * Track error with correct metadata
 */
export const trackErrorMesssage = (msg) => {
    TrackJS.addMetadata('pkg', 'nmp-trust');
    console.log(msg);
    TrackJS.track(msg);
    TrackJS.removeMetadata('pkg');
};
//# sourceMappingURL=errorTracking.js.map